// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3KpMY","content":"ManualTimeModal_content__1MJ3M"};